import React, { useEffect, useRef, useState } from 'react'
import { View, Text, ImageBackground, Dimensions, Pressable } from 'react-native'
import { Ionicons, Feather, AntDesign } from '@expo/vector-icons'
import styles from './GamificationRouletteStyles'
import { useNavigation } from '@react-navigation/native'
import { useGamification } from './context/gamification.context'
const width = Dimensions.get('window').width
import Constants from 'expo-constants'
import { RouletteComponent } from './RouletteComponent'
import { GradientText } from '../customUtils/Components/GradientText'
import { GamificationRouletteTheme } from '../../../themeConstants'

export const GamificationRoulette = ({ levelID, close }) => {
    const navigation = useNavigation()
    const {
        games,
        rouletteColors,
        selectedCategory,
        setSelectedCategory,
        getUserAttempts,
        setGameQuestions,
    } = useGamification()

    const viewTrivia = async (category) => {
        let pointsIfApproved = await findGameAttempts(category)
        let gameUpdated = await setGameQuestions(category)
        //   console.log('Juego actualizado:', JSON.stringify(gameUpdated))
        console.log('Puntos a sumar si se aprueba:', pointsIfApproved)

        let params = {
            level_id: levelID,
            game: gameUpdated,
            pointsIfApproved: pointsIfApproved,
        }
        navigation.navigate('GamificationGame', params)
        //close()
    }
    const [backgroundState, setBackgroundState] = useState(true)
    const imageOn = require('../../../assets/gamification/backgroundRouletteGameOn.png')
    const imageOff = require('../../../assets/gamification/backgroundRouletteGameOff.png')

    async function findGameAttempts(selectedCategory) {
        let pointsToSum = 0
        const fullPoints = selectedCategory.points || 0
        if (fullPoints == 0) return 0
        try {
            //Validar intentos anteriores del back / front locales y asignar en prevAttempts
            const prevAttempts = await getUserAttempts(levelID)
            // console.log('Intentos Previos:', prevAttempts)
            // let prevAttempts = 1

            switch (prevAttempts) {
                case 0: // Si el usuario no ha jugado
                    pointsToSum = fullPoints
                    break
                case 1: //Si el usuario falló 1 vez
                    pointsToSum = fullPoints / 2
                    pointsToSum = Math.round(pointsToSum)
                    break
                default: // Si el usuario falló + de una vez
                    pointsToSum = 0
                    break
            }
        } catch (e) {
            console.log('Error al buscar intentos del juego', e)
            return 0
        }
        return pointsToSum
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setBackgroundState((prevState) => !prevState)
        }, 500) // Cambiar cada 1 segundo

        return () => clearInterval(interval) // Limpiar el intervalo cuando el componente se desmonte
    }, [])
    return (
        <View
            style={[styles.imageBackground, { backgroundColor: 'rgba(0,0,0,0.9)' }]}
        >
            <ImageBackground
                source={backgroundState ? imageOn : imageOff}
                style={styles.imageBackground}
            >
                <View style={{ paddingTop: Constants.statusBarHeight, flex: 1 }}>
                    <View style={styles.rouletteContainer}>
                        <RouletteComponent
                            segments={games}
                            colors={rouletteColors}
                            returnSelectedCategory={(s) => {
                                setSelectedCategory(s)
                            }}
                            prevCategory={selectedCategory}
                        />
                    </View>
                    <View style={{ flex: 1 }}>
                        {selectedCategory && (
                            <View style={styles.selectedImageContainer}>
                                <Pressable
                                    onPress={() => viewTrivia(selectedCategory)}
                                >
                                    <ImageBackground
                                        source={require('../../../assets/gamification/toPlayButton.png')}
                                        style={[styles.playButton]}
                                        resizeMode='cover'
                                    >
                                        <View style={{ position: 'relative' }}>
                                            {/* Sombra detrás */}
                                            <Text
                                                style={[
                                                    styles.playButtonText,
                                                    {
                                                        color: GamificationRouletteTheme.playButtonTextColor,
                                                        position: 'absolute',
                                                        zIndex: 0,
                                                        textShadowColor:
                                                            GamificationRouletteTheme.playButtonTextColor,
                                                        textShadowOffset: {
                                                            width: 2,
                                                            height: 5,
                                                        },
                                                        textShadowRadius: 5,
                                                    },
                                                ]}
                                            >
                                                ¡A JUGAR!
                                            </Text>

                                            {/* Texto con gradiente arriba */}
                                            <GradientText
                                                colors={
                                                    GamificationRouletteTheme.gradientTextColors
                                                }
                                                style={styles.playButtonText}
                                            >
                                                ¡A JUGAR!
                                            </GradientText>
                                        </View>
                                    </ImageBackground>
                                </Pressable>
                            </View>
                        )}
                        <View style={styles.buttonContainer}>
                            <Pressable
                                onPress={() => {
                                    // setSelectedCategory(null)
                                    close()
                                }}
                            >
                                <View style={styles.xButton}>
                                    <Feather name='x' size={24} color={'white'} />
                                </View>
                            </Pressable>
                        </View>
                    </View>
                </View>
            </ImageBackground>
        </View>
    )
}
